var service = function($q) {
  var deferred;
  return {
    load: function() {
      if (deferred) { return deferred.promise; }

      deferred = $q.defer();

      window.initGoogleTranslate = function(d) {
        if (window.google) { deferred.resolve() }
      }

      var script = document.createElement('script');
      script.src = "//translate.google.com/translate_a/element.js?cb=initGoogleTranslate"
      if (window.RAILS_ENV !== 'test') {
        document.body.appendChild(script);
      }
       else {      
        setTimeout(window.initGoogleMaps, 0);
      }
      
      return deferred.promise;

    }
  };
};

service.$inject = ['$q'];

tiz.service('GoogleTranslate', service);
